<template>
    <div class="response radio">
        <p v-if="currentResponse.section"
           :class="{ 'section': true, 'first': currentResponse.id === 1 }"
        >
            {{ currentResponse.section }}
        </p>
        <input type="radio"
               class="response-input"
               :name="'quizz-radio-' + currentQuestion.id"
               :id="'quizz-radio-' + responseId"
               :value="responseId"
               @click="updateValue"
        />
        <label :for="'quizz-radio-' + responseId"
               class="response-label"
        >
            {{ currentResponse.label }}
        </label>
    </div>
</template>
<script>
    export default {
        props: [
            'question',
            'response'
        ],

        // REACTIVE PROPERTIES
        computed: {
            currentQuestion() {
                return this.question;
            },
            currentResponse() {
                return this.response;
            },
            responseId() {
                return this.currentQuestion.id + '-' + this.currentResponse.id;
            }
        },

        // METHODS
        methods: {
            updateValue() {
                this.$emit("input", this.responseId);
            }
        },

        // LIFECYCLE
        mounted() {
            this.$console.log('debug', 'Response::mounted');
        }
    }
</script>


// WEBPACK FOOTER //
// Response.vue?00d40d44